// src/pages/NotificacaoApp.js
"use client"

import { useState } from "react"
import axios from "axios"
import "../styles/taxasAdmin.css" // Vamos reaproveitar o estilo
import { FaBell, FaPaperPlane } from "react-icons/fa"

const NotificacaoApp = () => {
  const [titulo, setTitulo] = useState("")
  const [mensagemText, setMensagemText] = useState("")
  const [publicoAlvo, setPublicoAlvo] = useState("todos")
  const [loading, setLoading] = useState(false)
  const [feedback, setFeedback] = useState({ tipo: "", texto: "" })

  const dispararNotificacao = async () => {
    if (!titulo || !mensagemText) {
      setFeedback({ tipo: "erro", texto: "⚠ Informe o título e a mensagem." })
      return
    }

    if (!window.confirm(`Tem certeza que deseja enviar essa notificação para o público: ${publicoAlvo.toUpperCase()}?`)) {
      return
    }

    try {
      setLoading(true)
      setFeedback({ tipo: "", texto: "" })
      const token = localStorage.getItem("token")

      const resp = await axios.post(
        "https://api.ticketdovaqueiro.com/api/admin/disparar-push",
        { titulo, mensagem: mensagemText, publicoAlvo },
        { headers: { Authorization: `Bearer ${token}` } }
      )

      setFeedback({ tipo: "sucesso", texto: `✅ ${resp.data.mensagem}` })
      setTitulo("")
      setMensagemText("")
    } catch (err) {
      console.error("Erro ao disparar push:", err)
      setFeedback({ 
        tipo: "erro", 
        texto: err.response?.data?.erro || "❌ Erro no envio. Tente novamente." 
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="taxas-admin-container">
      <h2>
        <FaBell style={{ marginRight: 10 }} />
        Disparador do Aplicativo
      </h2>
      <p>Envie notificações push direto para o celular dos usuários do app Ticket do Vaqueiro.</p>

      {feedback.texto && (
        <div style={{
          padding: "15px", marginBottom: "20px", borderRadius: "8px", fontWeight: "bold",
          backgroundColor: feedback.tipo === "sucesso" ? "rgba(37, 211, 102, 0.2)" : "rgba(244, 67, 54, 0.2)",
          color: feedback.tipo === "sucesso" ? "#25D366" : "#f44336",
          border: `1px solid ${feedback.tipo === "sucesso" ? "#25D366" : "#f44336"}`
        }}>
          {feedback.texto}
        </div>
      )}

      <div className="taxa-form">
        <div className="form-group">
          <label>Público Alvo</label>
          <select value={publicoAlvo} onChange={(e) => setPublicoAlvo(e.target.value)}>
            <option value="todos">Todos os Usuários do App</option>
            <option value="cliente">Somente Vaqueiros (Clientes)</option>
            <option value="dono">Somente Organizadores (Donos)</option>
          </select>
        </div>

        <div className="form-group">
          <label>Título da Notificação (Curto e chamativo)</label>
          <input
            type="text"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
            placeholder="Ex: 🚀 Inscrições Abertas!"
            maxLength={50}
          />
        </div>

        <div className="form-group">
          <label>Mensagem</label>
          <textarea
            value={mensagemText}
            onChange={(e) => setMensagemText(e.target.value)}
            placeholder="Ex: A vaquejada do Parque Estrela acabou de abrir as senhas. Garanta a sua!"
            rows={4}
            style={{ width: "100%", padding: "10px", borderRadius: "8px", backgroundColor: "#1a1a1a", color: "#fff", border: "1px solid #333" }}
          />
        </div>

        <button onClick={dispararNotificacao} disabled={loading} style={{ marginTop: "15px", backgroundColor: "#f8c10b", color: "#000", fontWeight: "bold" }}>
          {loading ? "Disparando Lotes..." : <> <FaPaperPlane /> Disparar Notificação </>}
        </button>
      </div>
    </div>
  )
}

export default NotificacaoApp